import {
  LayoutDashboard,
  FolderOpen,
  Users,
  UserCog,
  CheckSquare,
  Palette,
  Languages,
  Library,
  Building2,
  HelpCircle,
  LucideIcon,
} from 'lucide-react';

export type UserRole = 'SUPER_ADMIN' | 'ADMIN' | 'PROJECT_MANAGER' | 'RESOURCE' | 'VIEWER' | 'DESIGN_TEAM' | 'LANGUAGE_TEAM';

export interface NavItem {
  name: string;
  path: string;
  icon: LucideIcon;
  roles?: UserRole[];
}

export interface NavSection {
  section: string;
  items: NavItem[];
}

export const navSections: NavSection[] = [
  {
    section: 'Main',
    items: [
      {
        name: 'Dashboard',
        path: '/dashboard',
        icon: LayoutDashboard,
        roles: ['SUPER_ADMIN', 'ADMIN', 'PROJECT_MANAGER', 'LANGUAGE_TEAM', 'DESIGN_TEAM'],
      },
    ],
  },
  {
    section: 'PM',
    items: [
      {
        name: 'Projects',
        path: '/projects',
        icon: FolderOpen,
        roles: ['PROJECT_MANAGER', 'ADMIN', 'SUPER_ADMIN', 'LANGUAGE_TEAM', 'DESIGN_TEAM'],
      },
      {
        name: 'Resources',
        path: '/resources',
        icon: Users,
        // LANGUAGE_TEAM intentionally omitted — language team members cannot
        // provision freelance resources or set their own team's freelancers.
        // DESIGN_TEAM keeps access so they can add design freelancers and
        // wire them up to their own team in DesignTeamManagement.
        roles: ['PROJECT_MANAGER', 'ADMIN', 'SUPER_ADMIN', 'DESIGN_TEAM'],
      },
      {
        name: 'Clients',
        path: '/clients',
        icon: Building2,
        roles: ['PROJECT_MANAGER', 'ADMIN', 'SUPER_ADMIN'],
      },
      {
        name: 'Language Teams',
        path: '/language-teams',
        icon: Languages,
        roles: ['PROJECT_MANAGER', 'ADMIN', 'SUPER_ADMIN', 'LANGUAGE_TEAM'],
      },
      {
        name: 'Design Teams',
        path: '/design-teams',
        icon: Palette,
        roles: ['PROJECT_MANAGER', 'ADMIN', 'SUPER_ADMIN', 'DESIGN_TEAM'],
      },
      {
        name: 'Contents',
        path: '/contents',
        icon: Library,
        roles: ['PROJECT_MANAGER', 'ADMIN', 'SUPER_ADMIN'],
      },
    ],
  },
  {
    section: 'Work',
    items: [
      {
        name: 'My Tasks',
        path: '/my-tasks',
        icon: CheckSquare,
        // visible to all roles including RESOURCE
      },
      {
        name: 'Design Review',
        path: '/design-review',
        icon: Palette,
        roles: ['SUPER_ADMIN', 'ADMIN', 'PROJECT_MANAGER', 'DESIGN_TEAM'],
      },
    ],
  },
  {
    section: 'System',
    items: [
      {
        name: 'User Management',
        path: '/users',
        icon: UserCog,
        roles: ['SUPER_ADMIN'],
      },
      {
        name: 'Assignment Rules',
        path: '/help/team-assignment-rules',
        icon: HelpCircle,
        roles: ['SUPER_ADMIN', 'ADMIN', 'PROJECT_MANAGER'],
      },
    ],
  },
];

export function getVisibleSections(role: UserRole): NavSection[] {
  return navSections
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) => !item.roles || item.roles.includes(role)
      ),
    }))
    .filter((section) => section.items.length > 0);
}
